export default __webpack_public_path__ + "static/media/nodejs-logo.f1d5b02e.png";